<template>
  <b-badge class="s-badge" v-bind="$attrs">
    <slot />
  </b-badge>
</template>

<script>
export default {
  name: 'SBadge',
}
</script>

<style scoped lang="scss">
.s-badge {
  padding: 0.25rem 0.5rem;
  border-radius: 0.875rem;
}
</style>
